import { SYS_SPACE_FIXED_150 } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledAudicodeWrapper = styled.div`
	.audicode-label-group {
		gap: 4px;
		${breakPoints({
			'375': `
			gap: 8px
		`,
		})}
	}

	.audicode-label {
		justify-content: center;
		width: 32px;
		min-height: 32px;
	}
`;

export const StyledMyAudiWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;

	${breakPoints({
		'768': `
			grid-template-columns: auto 1fr;
		`,
	})}
	ul {
		gap: 12px;
		display: grid;
		list-style-type: none;
		padding-left: 0;
	}

	li {
		display: flex;
		align-items: flex-start;
	}

	li::before {
		content: '>';
		font-size: 8px;
		line-height: 20px;
		margin-right: ${SYS_SPACE_FIXED_150};
	}

	button#login {
		${breakPoints({
			'768': `
				width: fit-content;
			`,
		})}
	}
`;

export const StyledMainContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;

	.subtitle {
		font-size: 14px;
	}
`;

export const StyledItemsContainer = styled.div`
	margin-top: 16px;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
`;
